// Import Libraries

global.htmx = require("htmx.org");
global.flowbite = require("flowbite");
global.validator = require("validator");
global.Sortable = require("sortablejs").Sortable;
global.Tagify = require("@yaireo/tagify");
global.Datadog = require("@datadog/browser-rum");
global.Strich = require("@pixelverse/strichjs-sdk");

// These have to be after above global assignments
require("htmx-ext-multi-swap");

// Global Variables

// This is the main side bar menu accordion
window.menuItemsAccordian = null;
window.mainImageCarousel = null;
window.scrollInterval = null;
window.mobileTabbarDrawer = null;
window.modal = null;
window.scanTimeoutId = null;
window.barcodeReader = null;

const licenseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI3YWM0YmM4OS1mMDc4LTQ0NjUtOWVjNC03ZDFjNDFhNmY3M2EiLCJpc3MiOiJzdHJpY2guaW8iLCJhdWQiOlsiaHR0cHM6Ly9zdGcuaWRlYXZvLmNvbSIsImh0dHBzOi8vY2xhcmtzLmlkZWF2by5jb20iLCJodHRwczovL21yZ3JlZW5zLmlkZWF2by5jb20iXSwiaWF0IjoxNzMxNDYxMTQ3LCJuYmYiOjE3MzE0NjExNDcsImNhcGFiaWxpdGllcyI6e30sInZlcnNpb24iOjF9.tQWZ9J4R5_OjbGzdLWcg6TcLQI5y1ctnE00tFSkbmDA";

// Lode Code

htmx.onLoad(function () {
  initFlowbite();
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", loadCode);
} else {
  loadCode();
}

async function loadCode() {
  console.log("Loading Code");

  setUpTabbarDrawer();
  setUpModal();
  addAllEventListeners();

  // This code shows the modal on root page laod if the root handler was called with the below query strings.
  const urlParams = new URLSearchParams(window.location.search);
  if (
    urlParams.has("showMultipleDevicesModal") ||
    urlParams.has("showSessionTimeoutModal") ||
    urlParams.has("showNoLicensesModal")
  ) {
    console.log("Modal show on intial page load");

    setTimeout(() => modal.show(), 1);
  }

  try {
    await Strich.StrichSDK.initialize(licenseKey);
  } catch (err) {
    let message = err.message;
    if (err.detailMessage) {
      message += "\n" + err.detailMessage;
    }
    console.log(`Barcode initialization failed: ${message}`);
  }

  const toolBar = document.getElementById("toolbar");
  const isViewable = !toolBar.classList.contains("hidden");
  if (isViewable) {
    document.documentElement.style.setProperty(
      "--mobile-header-height",
      "144px",
    );
  } else {
    document.documentElement.style.setProperty(
      "--mobile-header-height",
      "72px",
    );
  }
}

function addAllEventListeners() {
  // Event Listeners

  document.addEventListener("htmx:beforeTransition", function (event) {
    if (
      event &&
      event.detail &&
      event.detail.xhr &&
      event.detail.xhr.responseText
    ) {
      // Create a temporary element to parse the response text as HTML
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = event.detail.xhr.responseText;

      // Check for the specific element ID
      var modalContent = tempDiv.querySelector("#modal-content");

      if (modalContent) {
        console.log("Preventing default due to found '#modal-content'.");
        event.preventDefault();
      }
    }
  });

  document.addEventListener("htmx:beforeSend", function (event) {
    if (event) {
      // Clears the modal's content and shows the loadingSpinner
      if (
        event.srcElement.id === "create-user-button" ||
        event.srcElement.id === "update-user-button" ||
        event.srcElement.id === "create-role-button" ||
        event.srcElement.id === "update-role-button"
      ) {
        document.getElementById("loadingSpinner").classList.remove("hidden");
        document.getElementById("loadingBackdrop").classList.remove("hidden");

        document.getElementById("modal-content").innerHTML = "";
      }
    }
  });

  // Flowbite needs to be initialized after each htmx swap.
  document.addEventListener("htmx:afterSwap", function (event) {
    if (event) {
      console.log("After Swap");
      console.log(event.detail.pathInfo.requestPath);

      if (event.detail.pathInfo.requestPath === "/signin") {
        // htmx.ajax("#content", "get", "/home-content");
        // htmx.ajax("GET", "/home-content", "#load");
      }

      // Skips reinitialization of Flowbite when showing operationModal
      // if (
      //   event.detail.requestConfig.headers["HX-Target"] !== "modal-content" &&
      //   !event.detail.pathInfo.requestPath.endsWith("-content")
      // ) {
      // console.log('init flowbite')
      // initFlowbite();
      // }

      if (event.target.id === "toast-content") {
        console.log("#toast-content has swapped show toast");
        var toast = document.getElementById("toast");
        var toastContent = document.getElementById("toast-content");
        toast.classList.remove("hidden");
        toast.classList.remove("opacity-0");

        // target element that will be dismissed
        const targetEl = toast;

        // options object
        const options = {
          transition: "transition-opacity",
          duration: 5000,
          timing: "ease-out",
        };

        var dismiss = new Dismiss(targetEl, null, options);
        setTimeout(() => {
          // hide the target element
          dismiss.hide();

          initFlowbite();
        }, 2000);
      }

      // Opens modal if #modal-content has been swapped
      if (event.target.id === "modal-content") {
        console.log("#modal-content has swapped show modal");
        modal.show();
      }

      // go through all timestamps and convert it from utc to locale
      const timestamps = document.querySelectorAll(".timestamp");
      console.log("swap event timestamp");
      if (timestamps.length > 0) {
        console.log("swap event timestamps length > 0");
        for (const timestamp of timestamps) {
          timestamp.innerText = convertTimeStamp(timestamp.innerText);
        }
      }

      // Hides loadingSpinner every afterSwap
      document.getElementById("loadingBackdrop").classList.add("hidden");
      document.getElementById("loadingSpinner").classList.add("hidden");

      // const scan = document.getElementById("scan");
      // console.log("scan");
      // if (scan) {
      //   scan.addEventListener("click", function () {
      //     // Call the startScan function when the button is clicked
      //     startScan();
      //   });
      // }
    }
  });

  // This is used to open a modal window from the front end without making a call to the server
  document.addEventListener("showModal", function (event) {
    console.log("Caught show modal event.");
    if (event.detail.title && event.detail.message) {
      console.log("Title");
      var modalTitle = document.getElementById("modal-title");
      modalTitle.innerHTML = event.detail.title;

      var modalMessage = document.getElementById("modal-message");
      modalMessage.innerHTML = event.detail.message;

      modal.show();
    }
  });

  // This event clears out the file input field when uploading image files.
  document.addEventListener("htmx:afterRequest", function (event) {
    // Check if the event target is our file input form
    if (event.target.id === "product-images-upload-form") {
      var input = document.getElementById("product-images-dropzone-files");
      if (input) {
        input.value = ""; // Reset the file input
      }
    }

    // hide all spinners
    const spinners = this.getElementsByClassName("spinner");
    if (spinners) {
      for (const spinner of spinners) {
        // validate if spinner is hidden
        if (!spinner.classList.contains("hidden")) {
          spinner.classList.add("hidden");
        }
      }
    }

    // re-enable all buttons
    const button = event.target;
    button.disabled = false;
  });
}

// Functions

export function triggerLoading(event, spinnerId) {
  let spinnerEl;
  const buttonEl = event.currentTarget;

  if (spinnerId) {
    spinnerEl = document.getElementById(spinnerId);
  } else {
    spinnerEl = buttonEl.querySelector(".spinner");
  }

  // show spinner
  spinnerEl.classList.remove("hidden");
  // disable button
  buttonEl.disabled = true;
}

function setUpModal() {
  // create the modal
  const $modal = document.getElementById("modal");

  // modal options with default values
  const modalOptions = {
    placement: "center-center",
    backdrop: "static",
    closable: true,
    onHide: () => {
      console.log("modal is hidden");
      initFlowbite();
    },
    onShow: () => {
      console.log("modal is shown");
    },
    onToggle: () => {
      console.log("modal has been toggled");
    },
  };

  // modal instance options object
  const modalInstanceOptions = {
    id: "modal",
    override: true,
  };
  window.modal = new Modal($modal, modalOptions, modalInstanceOptions);
}

// Function to get the screen width
export function getScreenWidth() {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
}

export function closeModal() {
  modal.hide();
  initFlowbite();
}

// phone number functions
export function selectCountry(countryCode) {
  console.log("called");
  const country = {
    "+1": `<svg fill="none" aria-hidden="true" class="h-5 w-5 me-2" viewBox="0 0 20 15"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" style="mask-type:luminance" width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#D02F44" fill-rule="evenodd" d="M19.6.5H0v.933h19.6V.5zm0 1.867H0V3.3h19.6v-.933zM0 4.233h19.6v.934H0v-.934zM19.6 6.1H0v.933h19.6V6.1zM0 7.967h19.6V8.9H0v-.933zm19.6 1.866H0v.934h19.6v-.934zM0 11.7h19.6v.933H0V11.7zm19.6 1.867H0v.933h19.6v-.933z" clip-rule="evenodd"/><path fill="#46467F" d="M0 .5h8.4v6.533H0z"/><g filter="url(#filter0_d_343_121520)"><path fill="url(#paint0_linear_343_121520)" fill-rule="evenodd" d="M1.867 1.9a.467.467 0 11-.934 0 .467.467 0 01.934 0zm1.866 0a.467.467 0 11-.933 0 .467.467 0 01.933 0zm1.4.467a.467.467 0 100-.934.467.467 0 000 .934zM7.467 1.9a.467.467 0 11-.934 0 .467.467 0 01.934 0zM2.333 3.3a.467.467 0 100-.933.467.467 0 000 .933zm2.334-.467a.467.467 0 11-.934 0 .467.467 0 01.934 0zm1.4.467a.467.467 0 100-.933.467.467 0 000 .933zm1.4.467a.467.467 0 11-.934 0 .467.467 0 01.934 0zm-2.334.466a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.466a.467.467 0 11-.933 0 .467.467 0 01.933 0zM1.4 4.233a.467.467 0 100-.933.467.467 0 000 .933zm1.4.467a.467.467 0 11-.933 0 .467.467 0 01.933 0zm1.4.467a.467.467 0 100-.934.467.467 0 000 .934zM6.533 4.7a.467.467 0 11-.933 0 .467.467 0 01.933 0zM7 6.1a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.467a.467.467 0 11-.933 0 .467.467 0 01.933 0zM3.267 6.1a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.467a.467.467 0 11-.934 0 .467.467 0 01.934 0z" clip-rule="evenodd"/></g></g><defs><linearGradient id="paint0_linear_343_121520" x1=".933" x2=".933" y1="1.433" y2="6.1" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#F0F0F0"/></linearGradient><filter id="filter0_d_343_121520" width="6.533" height="5.667" x=".933" y="1.433" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_343_121520"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_343_121520" result="shape"/></filter></defs></svg>
      +1 <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/></svg>`,
    "+1 ": `<svg class="h-5 w-5 me-2"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve"><g>	<path style="fill:#F5F5F5;" d="M503.172,423.722H8.828c-4.875,0-8.828-3.953-8.828-8.828V97.101c0-4.875,3.953-8.828,8.828-8.828   h494.345c4.875,0,8.828,3.953,8.828,8.828v317.793C512,419.77,508.047,423.722,503.172,423.722z"/>	<rect x="114.76" y="88.278" style="fill:#F5F5F5;" width="282.48" height="335.45"/></g><g>	<path style="fill:#FF4B55;" d="M8.828,88.274C3.953,88.274,0,92.226,0,97.101v317.793c0,4.875,3.953,8.828,8.828,8.828h105.931   V88.274H8.828z"/>	<path style="fill:#FF4B55;" d="M503.172,88.274H397.241v335.448h105.931c4.875,0,8.828-3.953,8.828-8.828V97.101   C512,92.226,508.047,88.274,503.172,88.274z"/>	<path style="fill:#FF4B55;" d="M309.569,294.758l52.383-29.932l-12.02-6.01c-3.371-1.686-5.301-5.326-4.802-9.063l3.911-29.322   l-22.177,6.452c-4.899,1.426-9.983-1.588-11.085-6.569l-2.124-9.6l-20.823,24.37c-2.887,3.378-8.386,0.798-7.633-3.582   l8.893-51.708l-13.615,3.724c-3.977,1.088-8.177-0.722-10.116-4.36l-14.337-26.871v-0.04l-0.01,0.02l-0.011-0.02v0.04   l-14.337,26.871c-1.941,3.637-6.141,5.447-10.118,4.36l-13.616-3.724l8.893,51.708c0.753,4.378-4.747,6.959-7.634,3.582   l-20.823-24.37l-2.124,9.6c-1.102,4.982-6.186,7.994-11.085,6.569l-22.177-6.452l3.911,29.322c0.499,3.736-1.431,7.377-4.802,9.063   l-12.02,6.01l52.383,29.933c5.426,3.101,7.804,9.677,5.615,15.53l-4.478,11.977l44.885-3.832c2.484-0.212,4.598,1.788,4.525,4.279   l-1.414,48.044h8.828L259,322.711c-0.073-2.492,2.041-4.491,4.525-4.279l44.906,3.834l-4.478-11.977   C301.766,304.435,304.143,297.858,309.569,294.758z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
      +1 <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/></svg>`,
  };

  // Update button content
  document.getElementById("dropdown-phone-button").innerHTML =
    country[countryCode];

  // put country code in input_hidden
  document.getElementById("country-code").value = countryCode.trim();

  // Hide the dropdown after selecting a country
  const dropdownPhone = document.getElementById("dropdown-phone");
  if (dropdownPhone) {
    dropdownPhone.classList.add("hidden");
  }
}

export function formatPhoneNumber(input, isInput = true) {
  let value = isInput ? input.value : input.innerText;
  let cleaned = value.replace(/\D/g, "");

  if (/^\d*$/.test(cleaned)) {
    if (cleaned.length === 0) {
      input.value = "";
      input.innerText = "";
    } else if (cleaned.length < 4) {
      input.value = cleaned.replace(/^(\d{0,3})/, "($1");
      input.innerText = cleaned.replace(/^(\d{0,3})/, "($1");
    } else if (cleaned.length < 7) {
      input.value = cleaned.replace(/^(\d{3})(\d{0,3})/, "($1) $2");
      input.innerText = cleaned.replace(/^(\d{3})(\d{0,3})/, "($1) $2");
    } else {
      input.value = cleaned.replace(/^(\d{3})(\d{3})(\d{0,4})/, "($1) $2-$3");
      input.innerText = cleaned.replace(
        /^(\d{3})(\d{3})(\d{0,4})/,
        "($1) $2-$3",
      );
    }
  } else {
    if (isInput) {
      input.value = input.value.substring(0, input.value.length - 1);
    } else {
      input.innerText = input.innerText.substring(
        0,
        input.innerText.length - 1,
      );
    }
  }
}

// TODO This function is not being used, remove it.
function formatPrice(input, isInput = true) {
  // Determine whether to use value or innerText
  let target = isInput ? input.value : input.innerText;

  // Remove non-numeric characters except for the decimal point
  let cleaned = target.replace(/[^\d.]/g, "");

  // Split the number into dollars and cents
  let parts = cleaned.split(".");
  let dollars = parts[0];
  let cents = parts.length > 1 ? "." + parts[1].padEnd(2, "0") : "";

  // Add comma as a thousands separator
  dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine dollars and cents with a decimal point
  let formattedPrice = dollars + cents;

  // Update the input's value or innerText
  if (isInput) {
    input.value = formattedPrice;
  } else {
    input.innerText = formattedPrice;
  }
}

// TODO This function is not being used, remove it.
function handlePastePhoneNumber(input) {
  setTimeout(function () {
    formatPhoneNumber(input);
  }, 10);
}

export function removePhoneNumberFormatting(elementId) {
  let input = document.getElementById(elementId);

  if (input) {
    // Remove all non-numeric characters
    return input.value.replace(/\D/g, "");
  }
}

// Helper function that changes a hidden field value associated with a checkbox
export function updateCheckboxValue(checkbox, hiddenFieldId) {
  // If the checkbox is checked, set its value to "true", otherwise set to "false"
  checkbox.value = checkbox.checked ? "true" : "false";
  document.getElementById(hiddenFieldId).value = checkbox.value;
}

// Helper function that creates a read only FileList object from an array of files.
function createFileList(filesArray) {
  const dataTransfer = new DataTransfer();
  filesArray.forEach((file) => dataTransfer.items.add(file));
  return dataTransfer.files;
}

// Function that handles the file drag and drop event when image files are dragged into image file upload drop zone.
export function handleImageFileDrop(event, filesInput) {
  console.log("Handling drop image files.");

  preventDefaults(event); // Ensure default behavior is prevented

  var dt = event.dataTransfer;
  var files = dt.files;
  filteredFiles = validateImageFiles(files, filesInput);

  // Manually trigger the input to accept the dropped files
  if (filteredFiles && filteredFiles.length > 0) {
    filesInput.files = createFileList(filteredFiles);
    console.log(`Files dropped on drag: ${filesInput.files.length} file(s)`);

    // Trigger the htmx request manually if needed, or rely on hx-trigger="change"
    filesInput.dispatchEvent(
      new Event("submitUploadImagesForm", { bubbles: true }),
    );
    console.log("submitUploadImagesForm event dispatched");
  } else {
    console.log("No valid files dropped to process.");
  }
}

// Function that handles the file select change event when image files are selected from the file explorer for the image file upload.
export function handleImageFileSelect(event, filesInput) {
  console.log("Handling select image files.");

  preventDefaults(event); // Ensure default behavior is prevented

  const fileInput = event.target;
  const files = fileInput.files;
  const filteredFiles = validateImageFiles(files, filesInput);

  // Manually trigger the input to accept the dropped files
  if (filteredFiles && filteredFiles.length > 0) {
    filesInput.files = createFileList(filteredFiles);
    console.log(
      `Files selected in file explorer: ${filesInput.files.length} file(s)`,
    );

    // Trigger the htmx request manually if needed, or rely on hx-trigger="change"
    filesInput.dispatchEvent(
      new Event("submitUploadImagesForm", { bubbles: true }),
    );
    console.log("submitUploadImagesForm event dispatched");
  } else {
    console.log("No valid files selected to process.");
  }
}

// Function that validates the image files or zip file for type and size before they are uploaded to the server.
function validateImageFiles(files, filesInput) {
  var allowedFileTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
    "image/avif",
    "image/webp",
    "application/zip",
  ];
  var filteredFiles = [];

  if (files.length > 0) {
    console.log(`Dropped ${files.length} file(s)`);
    // Filter files based on type and size
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let fileSizeInKB = file.size / 1024; // size in KB
      if (allowedFileTypes.includes(file.type)) {
        if (
          (file.type === "application/zip" && fileSizeInKB <= 500000) || // ZIP files up to 500 MB
          (file.type !== "application/zip" && fileSizeInKB <= 500)
        ) {
          // Other specified types up to 200 KB
          filteredFiles.push(file);
        } else {
          fireShowModalEvent(
            "Error - No files were uploaded",
            `The file ${file.name} was too large at ${Math.round(
              fileSizeInKB,
            )} KB. Image files have to be less than 200 KB and zip files have to be less than 500 MB.`,
          );
          console.log(
            `No files were uploaded. The file ${
              file.name
            } was too large at ${Math.round(fileSizeInKB)} KB.`,
          );
          filesInput.value = "";
          return null;
        }
      } else {
        fireShowModalEvent(
          "Error - No files were uploaded",
          `The file ${file.name} was of the wrong type. Uploaded files need to be of type JPG, PNG, GIF, SVG, AVIF, WEBP or ZIP.`,
        );
        console.log(
          `No files were uploaded. The file ${file.name} was of the wrong type.`,
        );
        filesInput.value = "";
        return null;
      }
    }
  } else {
    fireShowModalEvent(
      "Error - No files were uploaded",
      `There were no files selected.`,
    );
    console.log(`No files were selected.`);
    filesInput.value = "";
    return null;
  }
  return filteredFiles;
}

// Function that prevents event defaults
export function preventDefaults(e) {
  e.preventDefault();
  e.stopPropagation();
}

// Function that fires a showModal event so that the modal window will open triggered from the front end.
function fireShowModalEvent(title, message) {
  console.log("showModalEvent");
  const showModalEvent = new CustomEvent("showModal", {
    detail: { title, message },
    bubbles: true,
    cancelable: true,
  });

  document.body.dispatchEvent(showModalEvent);
}

export function isLocationSelected(event) {
  var locationSelected = false;
  // Get all checkboxes with the class 'store-checkbox'
  const checkboxes = document.querySelectorAll(".store-checkbox");

  // Iterate over the checkboxes to check if any are checked
  for (let checkbox of checkboxes) {
    if (checkbox.checked) {
      locationSelected = true;
      break; // Return true if any checkbox is checked
    }
  }

  if (!locationSelected) {
    fireShowModalEvent("No Location Selected", "Please pick a location.");
    // hide spinner and re-enable button
    if (event) {
      const buttonEl = event.currentTarget;
      const spinner = buttonEl.querySelector(".spinner");
      buttonEl.disabled = false;
      spinner.classList.add("hidden");
    }
  }

  return locationSelected;
}

export function initializeDatadog(env) {
  Datadog.datadogRum.init({
    applicationId: "3e5616dc-cf52-4deb-9c11-96815e6db72f",
    clientToken: "pubb58550e531eb06ad07929ccffe5277bf",
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "us5.datadoghq.com",
    service: "ideavo",
    env: env,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
  });
}

// Changes the app color
function getCookie(name) {
  // Add the equals sign to the name to search for it more accurately in the cookie string
  name = name + "=";
  // Split document.cookie at semicolons into an array of cookies
  const decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  // Loop through the array of cookies
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    // Remove any leading spaces left by the split
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    // If this cookie's name matches the one we passed, return its value
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const convertTimeStamp = (timestamp) => {
  // Check if the timestamp is a valid number
  if (isNaN(Number(timestamp))) return timestamp;

  // Create a Date object from the timestamp
  const date = new Date(Number(timestamp));

  // Convert to local date with a 3-character month
  const localDate = date.toLocaleDateString(undefined, {
    month: "short", // 3-character month
    day: "numeric",
    year: "numeric",
  });

  // Convert to local time in 12-hour format with am/pm
  const localTime = date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true, // 12-hour format with am/pm
  });

  // Format time to lowercase for am/pm
  const formattedTime = localTime.toLowerCase();

  // Return the formatted date and time
  return `${localDate} ${formattedTime}`;
};

export function isSmallerThanSm() {
  return window.matchMedia("(max-width: 639px)").matches;
}

function setUpTabbarDrawer() {
  const $targetEl = document.getElementById("tabbar-drawer");
  const options = {
    placement: "bottom",
    backdrop: true,
    bodyScrolling: false,
    edge: true,
    edgeOffset: "bottom-[64px]",
    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
    onHide: () => {
      const menuLabelEl = document.getElementById(
        "tabbar-drawer-menu-button-text",
      );
      menuLabelEl.textContent = "More";
      console.log("drawer is hidden");
    },
    onShow: () => {
      const menuLabelEl = document.getElementById(
        "tabbar-drawer-menu-button-text",
      );
      menuLabelEl.textContent = "Less";
      console.log("drawer is shown");
    },
    onToggle: () => {
      console.log("drawer has been toggled");
    },
  };

  // instance options object
  const instanceOptions = {
    id: "tabbar-drawer-instance",
    override: true,
  };

  mobileTabbarDrawer = new Drawer($targetEl, options, instanceOptions);
}

export function isElementHidden(elementId) {
  var element = document.getElementById(elementId);
  if (element) {
    var style = window.getComputedStyle(element);
    return style.display === "none" || style.visibility === "hidden";
  }

  if (
    window.getComputedStyle(
      document.getElementById("activities-panel-{{ $notifyWhenIn.ID }}"),
    ).display !== "none" &&
    window.getComputedStyle(
      document.getElementById("activities-panel-{{ $notifyWhenIn.ID }}"),
    ).visibility !== "hidden"
  ) {
    event.preventDefault();
  }

  return true; // If the element doesn't exist, consider it as hidden
}

export async function showBarcodeScanner() {
  console.log("Show scanner.");

  try {
    // Show scanner UI
    document.getElementById("barcode-scanner").classList.remove("hidden");

    let configuration = {
      selector: "#barcode-scanner-video",
      frameSource: {
        resolution: "full-hd",
      },
      engine: {
        symbologies: ["upca", "upce", "ean13", "ean8", "code39", "code128"],
        duplicateInterval: 1500,
      },
    };

    try {
      // Initialize the barcode reader
      barcodeReader = await new Strich.BarcodeReader(
        configuration,
      ).initialize();
    } catch (initError) {
      console.error("Barcode reader initialization failed:", initError);
      fireShowModalEvent(
        "Error - Scanner",
        `Initializing barcode scanner: ${initError.message}`,
      );
      exitBarcodeScanner(barcodeReader);
      return;
    }

    barcodeReader.detected = (detections) => {
      try {
        if (detections.length > 0) {
          console.log("UPC Detected: ", detections[0].data);
          exitBarcodeScanner(barcodeReader);
          getProductDetail(detections[0].data);
        }
      } catch (detectError) {
        console.error("Error processing barcode detection:", detectError);
        fireShowModalEvent(
          "Error - Scanner",
          `Processing barcode: ${detectError.message}`,
        );
        exitBarcodeScanner(barcodeReader);
      }
    };

    try {
      await barcodeReader.start();
    } catch (startError) {
      console.error("Failed to start barcode scanner:", startError);
      fireShowModalEvent(
        "Error - Scanner",
        `Starting barcode scanner: ${startError.message}`,
      );
      exitBarcodeScanner(barcodeReader);
      return;
    }

    // Stop scanning after 20 seconds
    scanTimeoutId = setTimeout(() => exitBarcodeScanner(barcodeReader), 20000);
  } catch (generalError) {
    console.error("Unexpected error in barcode scanner:", generalError);
    fireShowModalEvent(
      "Error - Scanner",
      `Unexpected error in barcode scanner: ${generalError.message}`,
    );
    exitBarcodeScanner(barcodeReader);
  }
}

export function exitBarcodeScanner(barcodeReader) {
  if (scanTimeoutId) {
    clearTimeout(scanTimeoutId);
  }

  barcodeReader.destroy();
  document.getElementById("barcode-scanner").classList.add("hidden");
  console.log("Exit scanner.");
}

function getProductDetail(upc) {
  htmx.ajax("GET", "/scan-product", {
    swap: "multi:#page:outerHTML,#content:outerHTML,#tabbar-drawer:outerHTML,#modal-content:outerHTML,#breadcrumbs:outerHTML transition:true",
    values: { upc, screenwidth: getScreenWidth() },
  });
}
